<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import Portal from '../portal/Portal.svelte';
  import Button from '../button/Button.svelte';

  const dispatch = createEventDispatcher();

  // Closes the image editor window
  function closeEditor() {
    dispatch('close');
  }
</script>

<style lang="postcss">
  .imageEditor {
    display: grid;
    gap: 1rem;
  }

  @media (min-width: 640px) {
    .imageEditor {
      grid-template-columns: 1fr 10rem;
    }
  }

  .imageWrapper {
    position: relative;
    flex-grow: 1;
  }

  .imageEditor :global(img) {
    max-width: 100%;
    max-height: 100%;
  }

  .editorSidebar {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .editorSidebar :global(button) {
    justify-content: center;
    width: 100%;
  }
</style>

<Portal>
  <div class="imageEditor">
    <div class="imageWrapper">
      <slot name="content" />
    </div>
    <div class="editorSidebar">
      <slot name="actions" {closeEditor} />

      <Button variant="secondary" on:click={closeEditor}>Cancel</Button>
    </div>
  </div>
</Portal>
